import { HHTextField } from '@hinge-health/react-component-library';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

export interface DiscountInputProps {
  error?: FieldError;
  disabled?: boolean;
}

export const DiscountInput = ({
  error,
  disabled,
}: DiscountInputProps): JSX.Element => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name="discount"
      render={({ field: { onChange, value } }): JSX.Element => (
        <HHTextField
          hhVariant="variant-bypass"
          variant="outlined"
          id="discount"
          label="Discount (%)"
          type="number"
          value={value ?? ''}
          onChange={(e): void => {
            const parsed = parseFloat(e.target.value);
            onChange(isNaN(parsed) ? null : parsed);
          }}
          disabled={disabled}
          error={!!error}
          helperText={error?.message}
          inputProps={{ role: 'textbox', name: 'discount' }}
        />
      )}
    />
  );
};
